// Installs a global fetch wrapper so every same-origin /api request automatically
// carries the JWT, and any 401 (expired/invalid token) bounces the user back to
// the login screen. This means existing fetch() call-sites need no changes.
import { getToken, logout } from './auth';

export function installAuthFetch() {
  const original = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url =
      typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
    const isApi = url.startsWith('/api/') || url.includes('/api/agents');
    const isLogin = url.includes('/login');

    if (isApi && !isLogin) {
      const token = getToken();
      if (token) {
        const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
        headers.set('Authorization', `Bearer ${token}`);
        init = { ...init, headers };
      }
    }

    const res = await original(input as any, init);

    if (res.status === 401 && isApi && !isLogin) {
      // Token rejected — clear session and return to login.
      logout();
      if (!location.pathname.endsWith('/login')) {
        location.reload();
      }
    }
    return res;
  };
}
